import Request from "../constants/Request.api"
import Api from "../Api"

class Authentication extends Api {
  login = user => {
    const request = new Request({
      data: {
        username: user.username,
        password: user.password,
        url: "staff/login",
      },
    })

    return this.postRequest(request)
  }

  createPassword = user => {
    const request = new Request({
      data: {
        verification_code: user.verification_code,
        password: user.password,
        url: "staff/verify",
      },
    })

    return this.postRequest(request)
  }

  resetPassword = user => {
    const request = new Request({
      data: {
        username: user.username,
        url: "staff/reset-password",
      },
    })

    return this.postRequest(request)
  }
  logout = user => {}
}

export default Authentication
